import { dataContext } from "components/dataContext/dataContext";
import { AccountContext } from 'components/Account/Account';
import React, { useContext, useEffect, useMemo, useState } from "react";
import '../assets/css/dataTable.css';
import downloadCSV from '../csv/downloadCSV';
import ContainerResultadosCheckDocsBDS3FechaDesdeHasta from 'components/Container/ContainerResultadosCheckDocsBDS3FechaDesdeHasta';
import ContainerCheckDocsBDS3DesdeHasta from 'components/Container/ContainerCheckDocsBDS3DesdeHasta';
import ModalCargando from 'components/Modal/ModalCargando';
import ModalError from 'components/Modal/ModalError';
import checkDocumentosCargadosDesdeHasta from 'api/checkDocumentosCargadosDesdeHasta';

const errorMessages = {
  400: '- Bad Request',
  401: '- Unauthorized',
  403: '- Forbidden',
  404: '- Not Found',
  500: '- Internal Server Error',
  502: '- Bad Gateway',
  503: '- Service Unavailable',
  504: '- Gateway Timeout',
};

function CheckDocumentosCargadosDesdeHasta() {

  const { data } = useContext(dataContext);
  const { getSession } = useContext(AccountContext);
  const [showContainerCheckDocsBDS3DesdeHasta, setShowContainerCheckDocsBDS3DesdeHasta] = useState(true);
  const [tipodocumento, setTipodocumento] = useState('39');
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date().toISOString().slice(0, 10));
  const [filter, setFilter] = useState('');
  const [filtered, setFiltered] = useState(null);
  const [dataFiltered, setDataFiltered] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [modalTitleLoading, setModalTitleLoading] = useState('');
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showContainerResultadosCheckDocsBDS3FechaDesdeHasta, setShowContainerResultadosCheckDocsBDS3FechaDesdeHasta] = useState(false);
  const [showContainerTotalesBDS3DesdeHasta, setShowContainerTotalesBDS3DesdeHasta] = useState(false);
  const [tableData, setTableData] = useState(dataFiltered);

  const fixedHeader = true;

  let today = new Date();
  let miliseconds = today.getTime() - 24 * 60 * 60 * 1000;
  let yesterday = new Date(miliseconds);

  useEffect(() => {
    if (!dataFiltered || dataFiltered.length === 0) {
      setTableData([{
        tenantID: 'SIN REGISTROS',
        rut: 'SIN REGISTROS',
        nombreEmpresa: 'SIN REGISTROS',
        fecha: 'SIN REGISTROS',
        tipodocumento: 'SIN REGISTROS',
        total: 0,
        folios: 'SIN REGISTROS',
      }]);
      return;
    }
    setTableData(dataFiltered.map((item) => ({
      tenantID: item.tenantID,
      rut: item.rut,
      nombreEmpresa: item.nombreEmpresa,
      fecha: item.fecha,
      tipodocumento: item.tipodocumento,
      total: item.total,
      folios: item.folios,
    })));
  }, [dataFiltered, data]);

  function getFirstDayOfMonth(year, month) {
    return new Date(year, month, 1);
  }

  useEffect(() => {
    const firstDayCurrentMonth = getFirstDayOfMonth(
      yesterday.getFullYear(),
      yesterday.getMonth(),
    );
    setStartDate(firstDayCurrentMonth.toISOString().slice(0, 10));
    setEndDate(yesterday.toISOString().slice(0, 10));
  }, [])

 const busqueda = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      setShowErrorModal(true);
      setErrorMessage('Por favor, ingresa las fechas antes de realizar la búsqueda.');
      return;
    }
    setShowLoading(true);
    setModalTitleLoading('Consulta Comparación de Documentos');
    setLoadingDetail(true);
    setLoadingMessage(' Buscando Diferencias...');
    const params = { startDate, endDate, tipodocumento };
    const idToken = await getSession().then((session) => session.idToken.jwtToken);
    try {
      let response = await checkDocumentosCargadosDesdeHasta(idToken, params);
      if (response) {
        if (response.status === 200) {
          let responseData = response.data;
          if (responseData.data === undefined || Object.keys(responseData.data).length === 0) {
            // if (responseData.data.respuestaComparacionBDS3 === undefined || Object.keys(responseData.data.respuestaComparacionBDS3).length === 0) {
            setLoadingDetail(false);
            setModalTitleLoading('C2C BOLETAS CLOUD');
            setLoadingMessage('No existen datos que Comparar en la fecha seleccionada');
            return;
          } else {
            setShowLoading(false)
            setShowContainerResultadosCheckDocsBDS3FechaDesdeHasta(true);
            // setShowContainerTotalesBDS3DesdeHasta(true);
            dataCheck(responseData.data);
            return;
          }
        } else if (response.status >= 400 && response.status <= 504) {
          setShowLoading(false);
          setShowErrorModal(true);
          const msg = errorMessages[response.status] || 'Error en el Status de respuesta';
          setErrorMessage(`${msg}: ${response.message}`);
        }
      }
    } catch (error) {
      console.error(error);
      setLoadingMessage('Error', error);
      setLoadingDetail(false);
    }
  };

  const dataCheck = (response) => {
    try {
      const soloRut = Object.keys(response["foliosNoEncontrados"] || {});
      const filteredData = [];
      for (const rut of soloRut) {
        const empresa = response["foliosNoEncontrados"][rut];
        for (const tipoDocumento in empresa) {
          if (tipoDocumento === "name" || tipoDocumento === "tenant_id") continue;
          for (const fechaDocumento in empresa[tipoDocumento]) {
            const item = empresa[tipoDocumento][fechaDocumento];
            const total = Number(item?.total) || 0;
            const foliosCompress = Array.isArray(item?.foliosCompress) ? item.foliosCompress : [];
            if (total === 0 && foliosCompress.length === 0) continue;
            filteredData.push({
              tenantID: empresa.tenant_id,
              rut: rut,
              nombreEmpresa: empresa.name,
              fecha: fechaDocumento,
              tipodocumento: tipoDocumento,
              total,
              folios: foliosCompress.join(', '),
            });
          }
        }
      }
      setDataFiltered(filteredData);
      setFiltered(filteredData);
      setShowLoading(false);
      setLoadingDetail(false);
      setModalTitleLoading('');
      setLoadingMessage('');
    } catch (error) {
      setShowLoading(false);
      setLoadingDetail(false);
      setModalTitleLoading('');
      setLoadingMessage('');
      setShowErrorModal(true);
      setErrorMessage("Ocurrió un error al cargar los datos: " + error.message);
    }
  };

  const columns = [
    {
      name: 'Rut',
      selector: (row) => row.rut,
      sortable: true,
      wrap: true,
      width: '110px',
    },
    {
      name: 'Empresa',
      selector: (row) => row.nombreEmpresa,
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Fecha',
      selector: (row) => row.fecha,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Tipo doc',
      selector: (row) => row.tipodocumento,
      sortable: true,
      width: '100px',
    },
    {
      name: 'Total',
      selector: (row) => row.total,
      cell: (row) => <span className="dlq-count dlq-count--strong">{row.total ?? 0}</span>,
      sortable: true,
      right: true,
      width: '90px',
    },
    {
      name: 'Folios faltantes (rangos)',
      selector: (row) => row.folios,
      sortable: false,
      wrap: true,
      grow: 2,
    },
  ];

  const handleOnChangeFilterResultados = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    const searchValue = e.target.value.toLowerCase(); // Convertimos el valor de búsqueda a minúsculas

    try {
      if (!Array.isArray(filtered) || typeof setDataFiltered !== 'function') {
        setShowErrorModal(true);
        setErrorMessage('Error: filtered o setDataFiltered no están definidos correctamente.');
        return;
      }
      const aux = filtered.filter((element) => {
        const { rut, nombreEmpresa, fecha, tipodocumento, folios } = element;
        return (
          (rut && String(rut).toLowerCase().includes(searchValue)) ||
          (nombreEmpresa && nombreEmpresa.toLowerCase().includes(searchValue)) ||
          (fecha && fecha.toLowerCase().includes(searchValue)) ||
          (tipodocumento && String(tipodocumento).toLowerCase().includes(searchValue)) ||
          (folios && String(folios).toLowerCase().includes(searchValue))
        );
      });
      setTableData(aux);
    } catch (error) {
      setShowErrorModal(true);
      setErrorMessage('Ocurrió un error al filtrar los datos: ' + error.message);
    }
  };

  const resetModal = () => {
    handleClose()
  };

  const handleClose = () => {
    setStartDate(new Date().toISOString().slice(0, 10));
    window.location.reload();
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsText: 'Todos'
  };

  const actionsMemo = useMemo(
    () => ({
      onExport: () => {
        setShowLoading(true);
        setLoadingDetail(true);
        setModalTitleLoading('C2C BOLETAS CLOUD');
        setLoadingMessage('Exportando Datos...');
        const timestamp = new Date().toISOString().replace(/:/g, "-");
        const filename = `export_ResultadosCheckDocumentosBD/S3_${timestamp}.csv`;
        if (tableData.length === 0) {
          setLoadingDetail(false);
          setModalTitleLoading('C2C BOLETAS CLOUD');
          setLoadingMessage('No hay datos para exportar');
        } else {
          downloadCSV(tableData, filename);
          setLoadingDetail(false);
          setModalTitleLoading('C2C BOLETAS CLOUD');
          setLoadingMessage('Datos Exportados, documento generado: ' + filename);
        }
      }
    }),
    [tableData]
  );

  const handleClean = () => {
    setStartDate("");
    setEndDate("");
    setTipodocumento("");
    setShowContainerResultadosCheckDocsBDS3FechaDesdeHasta(false);
    // setShowContainerTotalesBDS3DesdeHasta(false)
  };

  const handleChangeTipoDocumento = (event) => {
    const selectedValue = event.target.value;
    setTipodocumento(selectedValue);
  };

  const HandleChaangeStartDate = (event) => {
    const selectedValue = event.target.value;
    setStartDate(selectedValue);
  };

  const HandleChaangeEndDate = (event) => {
    const selectedValue = event.target.value;
    setEndDate(selectedValue);
  };

  return (
    <div>
      {showContainerCheckDocsBDS3DesdeHasta && (
        <ContainerCheckDocsBDS3DesdeHasta
          showTitle="Check BD/S3 por rango de fechas"
          lastcheck={data.lastcheck}
          tipodocumento={tipodocumento}
          startDate={startDate}
          endDate={endDate}
          handleChangeTipoDocumento={handleChangeTipoDocumento}
          HandleChaangeEndDate={HandleChaangeEndDate}
          HandleChaangeStartDate={HandleChaangeStartDate}
          busqueda={busqueda}
          handleClean={handleClean}
        />
      )}
      {showContainerResultadosCheckDocsBDS3FechaDesdeHasta && (
        <ContainerResultadosCheckDocsBDS3FechaDesdeHasta
          columns={columns}
          filter={filter}
          handleOnChangeFilterResultados={handleOnChangeFilterResultados}
          actionsMemo={actionsMemo}
          fixedHeader={true}
          tableData={tableData}
        />
      )}
      {showErrorModal && (
        <ModalError
          showTitle="Ha ocurrido un error"
          showErrorModal={showErrorModal}
          errorMessage={errorMessage}
          resetModal={resetModal}
        />
      )}
      {showLoading && (
        <ModalCargando
          modalTitleLoading={modalTitleLoading}
          showLoading={showLoading}
          handleClose={handleClose}
          loadingDetail={loadingDetail}
          loadingMessage={loadingMessage}
        />
      )}
    </div>
  )
};

export default CheckDocumentosCargadosDesdeHasta;
